import { pick, pickBy } from 'lodash';

import type { EcsConfig, Experiment, ExperimentTreatments, FeatureRolloutTreatments } from '../../state/types';
import { experimentConfigs, featureRolloutNames } from '../../state/types';

export interface EcsPayload {
  readonly Headers: {
    readonly ETag: string;
  };
  readonly ConfigIDs: {
    readonly [configIdKey: string]: string;
  };
  readonly YammerClients: Partial<FeatureRolloutTreatments & ExperimentTreatments> | undefined;
  readonly CrossPlatform: Partial<FeatureRolloutTreatments & ExperimentTreatments> | undefined;
  readonly ClientForward: Partial<FeatureRolloutTreatments & ExperimentTreatments> | undefined;
}

export interface NormalizedEcsEntities {
  readonly ecsConfig: EcsConfig;
  readonly ecsExperimentTreatments: Partial<ExperimentTreatments>;
  readonly ecsFeatureRolloutTreatments: Partial<FeatureRolloutTreatments>;
}

type NormalizeEcsPayload = (payload: EcsPayload) => NormalizedEcsEntities;
export const normalizeEcsPayload: NormalizeEcsPayload = ({
  ConfigIDs: configIds,
  Headers: { ETag: etag },
  YammerClients: yammerClientsTreatments,
  CrossPlatform: crossPlatformTreatments,
  ClientForward: clientForwardTreatments,
}) => ({
  ecsConfig: { configIds, etag },
  ecsExperimentTreatments: {
    ...(yammerClientsTreatments
      ? pickBy(
          yammerClientsTreatments,
          (_, treatment: Experiment) =>
            experimentConfigs[treatment] && experimentConfigs[treatment].projectTeam === 'YammerClients'
        )
      : {}),
    ...(crossPlatformTreatments
      ? pickBy(
          crossPlatformTreatments,
          (_, treatment: Experiment) =>
            experimentConfigs[treatment] && experimentConfigs[treatment].projectTeam === 'CrossPlatform'
        )
      : {}),
    ...(clientForwardTreatments
      ? pickBy(
          clientForwardTreatments,
          (_, treatment: Experiment) =>
            experimentConfigs[treatment] && experimentConfigs[treatment].projectTeam === 'ClientForward'
        )
      : {}),
  },
  ecsFeatureRolloutTreatments: yammerClientsTreatments ? pick(yammerClientsTreatments, featureRolloutNames) : {},
});
